module.exports = __webpack_public_path__ + "img/kqr-header.2e0a4b1a.png";